import React from "react";
import { useTranslation } from "react-i18next";
import { utils } from "../../common/utils";

export default function LoyaltyTransactionsTable(props) {
  const { t } = useTranslation();

  const transactions = props.transactionsList;

  if (!transactions || transactions.length === 0) {
    return (
      <div className="alert alert-info fade show text-center margin-bottom-1x">
        <span className="alert-close" data-dismiss="alert"></span>
        <i className="icon-layers"></i>&nbsp;&nbsp;
        {t("No loyalty transactions found.")}
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover margin-bottom-none text-center">
        <thead>
          <tr>
            <th>{t("Transaction Date")}</th>
            <th>{t("Transaction Type")}</th>
            <th>{t("Balance")}</th>
            <th>{t("Notes")}</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((item) => (
            <tr key={item.id}>
              <td>{utils.dates.getDateString(item.transactionDate)}</td>
              <td>
                <span className="text-medium">
                  {props.getTransactionTypeName(item.transactionType)}
                </span>
              </td>
              <td>
                <span className="text-medium">{item.balance}</span>
              </td>
              <td>
                <span className="text-medium">{props.getNotesText(item)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
